import api from '@/apis/report/mergeReportAPI.js';
import Crud from '@/stores/crudBase';

var crud = new Crud('rpMergeReport', api);
const state = {
  ...crud.state,
  _config: {
    table: 'rp_report_merge_list',
    field: {
      key: 'id',
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
